module.exports = __webpack_public_path__ + "img/emoji_63.8df2884d.png";